/* Package JSON Import will be here */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
/* Package JSON Import will be here */

/* Project Import will be here */

import { ApiUrls } from '../../../services/api';
import Api from '../../../services/api/serviceCall';
import { Constants } from '../../../config/appConstants';
import * as utility from '../../../services/utility';
import { MessageBox } from '../../sharedComponent/messageBox';
import TimeCardDetailsEditComponent from './timeCardDetailsEdit.Component';

/* Project Import will be here */

class TimeCardDetailsEdit extends Component {
    constructor(props) {
        super(props);
        this.state = {
            //Display Purpose
            employeeID: 0,
            employeeName: "",
            employeeNumber: "",
            selectedDate: "",
            timecards: [],
            savedTimeCards: [],
            statusCodeOptions: [],
            statusCodeList: [],

            //Dropdown DataSources
            projectOptions: [],
            shiftOptions: [
                { key: 0, value: Constants.DAY, text: Constants.DAY },
                { key: 1, value: Constants.EVENING, text: Constants.EVENING },
                { key: 2, value: Constants.NIGHT, text: Constants.NIGHT },
            ],
            workDoneOptions: [
                { key: 0, value: 'yes', text: 'Yes' },
                { key: 1, value: 'no', text: 'No' }
            ],

            //TaskCode Selection Section
            isShowSelectTaskCode: false,
            editedTimecardIndex: 0,
            selectedProjectID: 0,
            selectedProjectNumber: 0,
            statusCodeDataList: [],
            selectedTaskNumber: "",
            selectedTaskName: "",

            //Attachments
            isViewAttachmentModelVisible: false,
            selectedAttachment: {},

            isSaveButtonDisabled: false,
            isShowLoader: false,

            //Save Confirmation popup
            isShowTimecardsSaveConfirmation: false,
            deviceName: '',
            isTimeCardAttested: false,
            isShowAttestationErrorModal: false,
            attestErrorValidationMessage: ""
        };
    };

    componentDidMount() {
        window.history.pushState(null, null, window.location.href);
        window.onpopstate = this.handleBlockedBackButton;

        const params = new URLSearchParams(this.props?.location?.search ?? "");
        if (params.size === 0) {
            this.props.history.push("/TimeCard");
            return;
        }

        const timeCardIds = params.get('tids')?.split(',')?.map(Number) ?? null;
        const selectedDate = params.get('sd') ?? null;

        if (!timeCardIds || !selectedDate) {
            this.props.history.push("/TimeCard");
            return;
        }

        const device = this.props.user.deviceEmpID.split('_');
        device.shift();
        device.pop();
        const deviceName = device.join('_');

        this.setState({ selectedDate: selectedDate, deviceName }, () => {
            this.DeleteUnassignedAndInactiveProjectTimecards(timeCardIds);
            this.getProjectsByDeviceId();
        });
        this.getStatusCodeList();
    }

    handleBlockedBackButton = () => {
        let { isShowSelectTaskCode } = this.state;
        if (isShowSelectTaskCode) {
            window.history.pushState(null, null, window.location.href);
            this.setState({ isShowSelectTaskCode: false });
        }
        else {
            this.onCloseShowTimecardsSaveConfirmation();
        }
    };

    getTimecards = (timeCardIds) => {
        var requestData = {
            DeviceId: this.props.device.deviceId,
            SelectedDate: this.state.selectedDate,
            TimeCardIds: timeCardIds
        };

        let url = `${ApiUrls.Routes.TME_CRD_C}${ApiUrls.Routes.GT_TMECRDS}`;
        Api.Post(url, requestData, this).then((responseData) => {
            if (responseData.success) {
                if (responseData.data && responseData.data.length > 0) {
                    let timecards = responseData.data ? responseData.data : [];
                    let employeeName = timecards[0] ? timecards[0].fullName : "";
                    let employeeNumber = timecards[0] ? timecards[0].employeeNumber : "";
                    let employeeID = timecards[0] ? timecards[0].employeeID : 0;

                    for (let timecard of timecards) {
                        let stHours = 0, dtHours = 0, otHours = 0;

                        if (timecard.attachments.length > 0) {
                            timecard.attachments.sort((a, b) => a.id - b.id);
                        }

                        for (let timecardHour of timecard.timeRecordHours) {
                            switch (timecardHour.hoursType) {
                                case "ST":
                                case "ST2":
                                case "ST3":
                                    stHours = timecardHour.hours;
                                    break;
                                case "OT":
                                case "OT2":
                                case "OT3":
                                    otHours = timecardHour.hours;
                                    break;
                                case "DT":
                                    dtHours = timecardHour.hours;
                                    break;
                                default:
                                    break;
                            }
                            timecard.stHours = stHours;
                            timecard.otHours = otHours;
                            timecard.dtHours = dtHours;
                        }

                        timecard.expectationUnits = timecard.expectationUnits ? timecard.expectationUnits.toString() : "";
                        timecard.workUnits = timecard.workUnits ? timecard.workUnits.toString() : "";
                        timecard.expectationNote = timecard.expectationNote?.toString() ?? "";
                        timecard.workNote = timecard.workNote?.toString() ?? "";

                        timecard.jobOverride = timecard.jobOverride?.toString() ?? "";
                        timecard.unionOverride = timecard.unionOverride?.toString() ?? "";
                    }
                    const isTimeCardAttested = timecards.some(a => a.attestationStatus);
                    this.previouslySelectedProject(timecards[0].projectID);
                    this.setState({
                        timecards: timecards,
                        savedTimeCards: _.cloneDeep(timecards),
                        employeeName: employeeName,
                        employeeNumber: employeeNumber,
                        employeeID: employeeID,
                        isTimeCardAttested
                    });
                } else {
                    this.props.history.goBack();
                }
            }
            else {
                MessageBox(responseData.message, Constants.ERROR);
            }
        });
    }

    previouslySelectedProject = async (projectID) => {

        let { projectOptions } = this.state;
        if (projectOptions.length === 0) {
            let url = `${ApiUrls.Routes.PJT_C}${ApiUrls.Routes.GT_AAPBDID_M}?deviceId=${this.props.device.deviceId}`;
            await Api.Post(url, {}, this, false).then((responseData) => {
                try {
                    if (responseData.success && responseData.data) {
                        responseData.data.sort((a, b) => b.projectNumber - a.projectNumber).map(a => {
                            return projectOptions.push({ key: a.id, text: `${a.projectNumber} - ${a.projectName}`, value: a.id, projectnumber: a.projectNumber });
                        });
                    }
                }
                catch (err) {
                    MessageBox(err.message, Constants.ERROR);
                }
            });
        }

        const selectedProject = projectOptions.find(a => a.key === projectID);
        this.setState(prevState => ({
            selectedProject,
            projectOptions: [selectedProject,
                ...prevState.projectOptions.filter(a => a.key !== selectedProject.key)
                    .sort((a, b) => b.projectnumber - a.projectnumber)]
        }));

    }

    getStatusCodeList() {
        let url = `${ApiUrls.Routes.FLDSTSCD_C}${ApiUrls.Routes.GT_A_FSCDLTWB_M}`;
        Api.Post(url, {}, this, false).then((responseData) => {
            if (responseData.success && responseData.data != null) {
                let emptyStatusCode = { key: 0, text: "-Select-", value: 0, id: 0 };
                let statusCodeOptions = responseData.data.map(s => {
                    return ({ key: s.id, text: s.statusInitial + "-" + s.displayText, value: s.id });
                })
                this.setState({
                    statusCodeDataList: [emptyStatusCode, ...statusCodeOptions],
                    statusCodeList: [emptyStatusCode, ...responseData.data]
                });
            }
        });
    }

    getProjectsByDeviceId = () => {
        let url = `${ApiUrls.Routes.PJT_C}${ApiUrls.Routes.GT_AAPBDID_M}?deviceId=${this.props.device.deviceId}`;
        Api.Post(url, {}, this, false).then((responseData) => {
            try {
                if (responseData.success) {
                    var projectOptions = [];

                    if (responseData.data) {
                        responseData.data.sort((a, b) => b.projectNumber - a.projectNumber).map(a => {
                            return projectOptions.push({ key: a.id, text: `${a.projectNumber} - ${a.projectName}`, value: a.id, projectnumber: a.projectNumber });
                        });
                    }
                    this.setState({ projectOptions: projectOptions });
                }
                else {
                    MessageBox(responseData.message, Constants.ERROR);
                }
            }
            catch (err) {
                MessageBox(err.message, Constants.ERROR);
            }
        });
    }

    handleInputChange = (event, index, inputName) => {
        let { timecards, projectOptions, shiftOptions, statusCodeList } = this.state;
        var editedTimecard = timecards[index];

        switch (inputName) {
            case Constants.PROJECT_DROPDOWN:
                var projectOption = projectOptions.filter(f => f.value === event);
                let selectedProject = projectOption[0].text.split("-");
                editedTimecard.projectID = projectOption[0].value;
                editedTimecard.projectNumber = selectedProject && selectedProject[0] ? selectedProject[0].trim() : "";
                editedTimecard.projectName = selectedProject && selectedProject[1] ? selectedProject[1].trim() : "";
                editedTimecard.taskCodeID = 0;
                editedTimecard.taskNumber = "";
                editedTimecard.taskName = "";
                this.previouslySelectedProject(projectOption[0].value);
                break;
            case Constants.SHIFT_DROPDOWN:
                var shiftOption = shiftOptions.filter(f => f.value === event);
                editedTimecard.shift = shiftOption[0].value;
                break;
            case Constants.WORKDONE_CHECKBOX:
                var workDoneAtJobSite = this.state.workDoneOptions.find(a => a.text !== event);
                editedTimecard.workDoneAtJobSite = workDoneAtJobSite.text;
                break;
            case Constants.STATUSCODE_DROPDOWN:
                let statusCodeListOption = statusCodeList.find(a => a.id === event);
                if (statusCodeListOption !== null && statusCodeListOption.id > 0 && statusCodeListOption.displayText !== '-Select-' && statusCodeListOption.statusInitial !== "") {
                    editedTimecard.fieldStatusId = statusCodeListOption.id;
                    editedTimecard.fieldStatusDescription = statusCodeListOption.displayText;
                    editedTimecard.fieldStatusInitial = statusCodeListOption.statusInitial;
                }
                else {
                    editedTimecard.fieldStatusId = null;
                    editedTimecard.fieldStatusDescription = null;
                    editedTimecard.fieldStatusInitial = null;
                }
                break;
            case Constants.ST_HOURS:
                let stHour = this.getHoursValue(event.target.value);
                editedTimecard.stHours = stHour;
                break;
            case Constants.OT_HOURS:
                let otHour = this.getHoursValue(event.target.value);
                editedTimecard.otHours = otHour;
                break;
            case Constants.DT_HOURS:
                let dtHour = this.getHoursValue(event.target.value);
                editedTimecard.dtHours = dtHour;
                break;
            case Constants.PAYROLL_NOTES:
                if (event.target.value.length <= 250) {
                    editedTimecard.payRollNote = event.target.value;
                }
                else {
                    MessageBox(Constants.MAXLENGTH_REACHED, Constants.ERROR);
                    return;
                }
                break;
            case Constants.ACTUAL_UNITS:
                editedTimecard.workUnits = utility.allowOnlyPositiveNumeric(event.target.value);
                break;
            case Constants.ACTUAL_NOTES:
                if (event.target.value.length <= 1000) {
                    editedTimecard.workNote = event.target.value;
                }
                else {
                    MessageBox(Constants.MAXLENGTH_REACHED, Constants.ERROR);
                    return;
                }
                break;
            case Constants.EXPECTATIONAL_UNITS:
                editedTimecard.expectationUnits = utility.allowOnlyPositiveNumeric(event.target.value);
                break;
            case Constants.EXPECTATIONAL_NOTES:
                if (event.target.value.length <= 1000) {
                    editedTimecard.expectationNote = event.target.value;
                }
                else {
                    MessageBox(Constants.MAXLENGTH_REACHED, Constants.ERROR);
                    return;
                }
                break;
            case Constants.JOB_OVERRIDE:
                editedTimecard.jobOverride = event.target.value;
                break;
            case Constants.UNION_OVERRIDE:
                editedTimecard.unionOverride = event.target.value;
                break;
            default:
                break;
        }

        editedTimecard.modifiedBy = Constants.ROSENDINTIME_USER;
        editedTimecard.modifiedDate = new Date();

        timecards[index] = editedTimecard;
        this.setState({ timecards });
    }

    onShowSelectTaskCodePage = (index) => {
        let { timecards } = this.state;
        let editedTimecard = timecards[index];

        this.setState({
            isShowSelectTaskCode: true,
            editedTimecardIndex: index,
            selectedProjectID: editedTimecard.projectID,
            selectedProjectNumber: editedTimecard.projectNumber,
            selectedTaskNumber: editedTimecard.taskNumber,
            selectedTaskName: editedTimecard.taskName
        });
    }

    onHandleSelectTaskCodePageSelection = (userSelectedTaskCodeID, userSelectedTaskName, userSelectedTaskNumber) => {
        let { timecards, editedTimecardIndex } = this.state;
        if (timecards[editedTimecardIndex]) {
            timecards[editedTimecardIndex].taskCodeID = userSelectedTaskCodeID;
            timecards[editedTimecardIndex].taskName = userSelectedTaskName;
            timecards[editedTimecardIndex].taskNumber = userSelectedTaskNumber;
        }
        this.setState({
            isShowSelectTaskCode: false,
            timecards: timecards,
            selectedTaskNumber: userSelectedTaskNumber,
            selectedTaskName: userSelectedTaskName
        });
    }

    onHandleSelectTaskCodePageBackButton = () => {
        this.setState({
            isShowSelectTaskCode: false
        });
    }

    //Todo : Need to common code of fileupload process
    onAddActulNoteAttachment = (editedTimecardIndex, images) => {
       const { timecards } = this.state;
       this.setState({ isSaveButtonDisabled: true }, () => {
           const attachments = timecards[editedTimecardIndex]?.attachments ?? [];
           utility.maximumImageCheck(attachments, images, true).then((data) => {
               if (data.success) {
                   timecards[editedTimecardIndex].attachments = attachments;
                   this.setState({ timecards, isSaveButtonDisabled: false });
                   return timecards;
               }
               else {
                   this.setState({ isSaveButtonDisabled: false });
               }
           });
       });
   }

    onRemoveActualNoteAttachment = (editedTimecardIndex, attachmentIndex) => {
        let { timecards } = this.state;
        if (timecards[editedTimecardIndex].attachments[attachmentIndex].id > 0) {
            timecards[editedTimecardIndex].attachments[attachmentIndex].isActive = false
        } else {
            timecards[editedTimecardIndex].attachments.splice(attachmentIndex, 1);
        }

        this.setState({
            timecards
        });
    }

    onClickViewActaulNoteAttachment(attachment) {
        this.setState({
            isViewAttachmentModelVisible: true,
            selectedAttachment: attachment
        });
    }

    onCloseViewAttachment() {
        this.setState({
            isViewAttachmentModelVisible: false,
            selectedAttachment: {}
        });
    }

    onClickAddNewLineButton = () => {
        let { timecards, employeeID, employeeName, employeeNumber, deviceName, isTimeCardAttested } = this.state;
        if (isTimeCardAttested) {
            this.setState({ isShowAttestationErrorModal: true, attestErrorValidationMessage: Constants.ADD_UPDATE_TIMECARD_ALREADY_ATTESTED_MESSAGE });
            return;
        }
        var timecard = {
            attachments: [],
            createdDate: new Date(this.state.selectedDate),
            deviceID: this.props.device.deviceId,
            deviceName: deviceName,
            dtHours: "", //
            employeeID: employeeID,
            employeeNumber: employeeNumber,
            expectationNote: "",
            expectationUnits: "",
            fullName: employeeName,
            intStatus: Constants.IN_PROGRESS,
            isDeleted: false,
            jobOverride: "",
            startTime: this.state.timecards[0]?.startTime ?? "",
            endTime: this.state.timecards[0]?.endTime ?? "",
            lunchStartTime: this.state.timecards[0]?.lunchStartTime ?? "",
            lunchEndTime: this.state.timecards[0]?.lunchEndTime ?? "",
            otHours: "",
            payRollNote: "",
            projectID: 0,
            projectName: "",
            projectNumber: "",
            shift: "",
            stHours: "",
            taskCodeID: 0,
            taskNumber: "",
            taskName: "",
            timeRecordID: 0,
            unionOverride: "",
            workDoneAtJobSite: this.state.workDoneOptions[0].text,
            workUnits: "",
            workNote: "",
            day: this.state.timecards[0] ? this.state.timecards[0].day : '',
            weekEndingDate: this.state.timecards[0] ? this.state.timecards[0].weekEndingDate : '',
            createdDate: this.state.timecards[0] ? this.state.timecards[0].createdDate : new Date(),
            createdBy: Constants.ROSENDINTIME_USER,
            creationDate: new Date(),
            modifiedBy: Constants.ROSENDINTIME_USER,
            submittedByEmployeeId: this.props.user.employeeId,
            modifiedDate: new Date(),
            isDupicate: false
        }

        timecards.splice(0, 0, timecard);
        this.setState({ timecards });
    }

    onClickSaveButton = () => {
        try {
            if (!this.state.isSaveButtonDisabled) {
                this.setState({ isSaveButtonDisabled: true, isShowLoader: true, isShowTimecardsSaveConfirmation: false }, () => {
                    let { timecards: copyTimecard } = this.state;
                    let timecards = JSON.parse(JSON.stringify(copyTimecard));
                    let isValidData = true;
                    var duplicateValidatedObjs = [];
                    var alertMessage = "";
                    const isZeroTimeCard = timecards.every(a => Number(a.stHours) === 0 && Number(a.otHours) === 0 && Number(a.dtHours) === 0);
                    if (isZeroTimeCard) {
                        timecards.map(a => {
                            a.startTime = Constants.NOT_APPLICABLE;
                            a.endTime = Constants.NOT_APPLICABLE;
                            a.lunchStartTime = Constants.NOT_APPLICABLE;
                            a.lunchEndTime = Constants.NOT_APPLICABLE;
                        });
                    }

                    if (timecards && timecards.length > 0) {
                        for (let timecard of timecards) {

                            let stDayShiftHours = 0;
                            let stEveningShiftHours = 0;
                            let stNightShiftHours = 0;

                            timecards.filter(t => {
                                if (t.employeeID === timecard.employeeID && !t.isDeleted) {
                                    if (t.shift === Constants.DAY) {
                                        stDayShiftHours += Number(t.stHours);
                                    }
                                    else if (t.shift === Constants.EVENING) {
                                        stEveningShiftHours += Number(t.stHours);
                                    }
                                    else if (t.shift === Constants.NIGHT) {
                                        stNightShiftHours += Number(t.stHours);
                                    }
                                }
                                return t;
                            });

                            if (!(duplicateValidatedObjs && duplicateValidatedObjs.find(a => a.employeeID == timecard.employeeID && a.projectID == timecard.projectID && a.taskCodeID == timecard.taskCodeID))) {
                                var duplicateRecord = timecards.filter(c => c.employeeID === timecard.employeeID && c.projectID === timecard.projectID && c.taskCodeID === timecard.taskCodeID && c.shift === timecard.shift && !c.isDeleted);
                                if (duplicateRecord && duplicateRecord.length === 1 && timecard.isDupicate) {
                                    timecard.isDupicate = false;
                                }
                                if (duplicateRecord && duplicateRecord.length > 1 && timecard.projectID && timecard.taskCodeID && timecard.shift) {
                                    duplicateValidatedObjs.push(duplicateRecord[0]);
                                    isValidData = false;
                                    alertMessage = Constants.TIMECARD_IS_DUPLICATE;
                                    var isFirstRecord = true;
                                    let duplicateRecords = duplicateRecord.reverse();
                                    for (let dt of duplicateRecords) {
                                        if (!isFirstRecord) {
                                            dt.isDupicate = true;
                                        }
                                        else if (dt.isDupicate) {
                                            dt.isDupicate = false
                                        }
                                        isFirstRecord = false;
                                    }
                                    this.setState({ isSaveButtonDisabled: false, isShowLoader: false, timecards });
                                }
                                else if (!timecard.projectID && isValidData) {
                                    alertMessage = Constants.SELECT_VALID_PROJECT;
                                    isValidData = false;
                                }
                                else if (!timecard.isDeleted && (!timecard.taskName || !timecard.taskCodeID) && isValidData) {
                                    alertMessage = Constants.SELECT_VALID_TASK_CODE;
                                    isValidData = false;
                                }
                                else if (!timecard.shift && isValidData) {
                                    alertMessage = Constants.SELECT_VALID_SHIFT;
                                    isValidData = false;
                                }
                                else if (timecard.workDoneAtJobSite === '' && isValidData) {
                                    alertMessage = Constants.PLEASE_CHOOSE_WORK_DONE;
                                    isValidData = false;
                                }
                                else if (((stDayShiftHours > 10) || (stEveningShiftHours > 10) || (stNightShiftHours > 10)) && isValidData) {
                                    alertMessage = Constants.ST_HOURS_CANNOT_BE_GREATER;
                                    isValidData = false;
                                }
                            }
                        }
                        if (alertMessage) {
                            MessageBox(alertMessage, Constants.ERROR);
                            this.setState({ isSaveButtonDisabled: false, isShowLoader: false, timecards });
                        }
                    }
                    else {
                        MessageBox(Constants.PLEASE_SELECT_SOME_TIMECARDS, Constants.ERROR);
                        this.setState({ isSaveButtonDisabled: false, isShowLoader: false });
                        isValidData = false;
                    }

                    if (isValidData) {
                        var todayDate = new Date();
                        var lastday = (new Date(todayDate.setDate(todayDate.getDate() - todayDate.getDay() + 7)));

                        //TODO: Need to fetch deviceEmpID and update the reducer
                        // var splitDeviceEmpId = this.props.device.deviceEmpId ? this.props.device.deviceEmpId.split("_", 2) : "";
                        // var deviceName = splitDeviceEmpId[1];

                        for (let timecard of timecards) {
                            if (!timecard.timeRecordHours) {
                                timecard.timeRecordHours = [];
                            }

                            if (timecard.timeRecordHours.length > 0) {
                                //Clearing out existing newly added items here and we will re-pushing items again.
                                timecard.timeRecordHours = timecard.timeRecordHours.filter(t => t.id > 0);
                            }

                            this.addOrUpdateTimeRecordHours(timecard, ((timecard.stHours == "" || timecard.stHours == "0") ? 0 : timecard.stHours), Constants.ST, [Constants.ST, Constants.ST2, Constants.ST3]);
                            this.addOrUpdateTimeRecordHours(timecard, ((timecard.otHours == "" || timecard.otHours == "0") ? 0 : timecard.otHours), Constants.OT, [Constants.OT, Constants.OT2, Constants.OT3]);
                            this.addOrUpdateTimeRecordHours(timecard, ((timecard.dtHours == "" || timecard.dtHours == "0") ? 0 : timecard.dtHours), Constants.DT, [Constants.DT]);
                            timecard.stHours = Number(utility.hoursFormation(timecard.stHours));
                            timecard.otHours = Number(utility.hoursFormation(timecard.otHours));
                            timecard.dtHours = Number(utility.hoursFormation(timecard.dtHours));
                            timecard.expectationUnits = Number(timecard.expectationUnits);

                            if (!Number(timecard.stHours) && !Number(timecard.otHours) && !Number(timecard.dtHours) && timecard.timeRecordHours.length === 0) {
                                timecard.timeRecordHours.push({
                                    id: 0,
                                    hours: Number(utility.hoursFormation(timecard.stHours)).toString(),
                                    hoursType: this.getHoursTypeCode(timecard.shift, Constants.ST),
                                    timeRecordID: timecard.timeRecordID > 0 ? timecard.timeRecordID : 0,
                                    deviceID: this.props.device.deviceId,
                                    isDelete: false
                                });
                            }


                            //Need to confirm with team about below below coding logic is required!
                            if (timecard.timeRecordID > 0 && timecard.timeRecordHours && timecard.timeRecordHours.length > 0) {
                                timecard.timeRecordHours.map(b => {
                                    if (timecard.timeRecordHours.length === 1 && b.hoursType === Constants.ST && Number(b.hours) > 0 && Number(timecard.stHours) === 0) {
                                        b.hours = Number(utility.hoursFormation(timecard.stHours)).toString();
                                        b['isUpdated'] = true;
                                    }
                                    var isZeroHours = false;
                                    if (timecard.timeRecordHours.length === 1 && (b.hoursType === Constants.ST || b.hoursType === Constants.ST2 || b.hoursType === Constants.ST3) && Number(b.hours) === 0) {
                                        isZeroHours = true;
                                        b.hoursType = this.getHoursTypeCode(timecard.shift, Constants.ST);
                                    }
                                    if (typeof (b.isUpdated) === 'undefined' && !isZeroHours && b.id !== 0) {
                                        b.isDelete = true;
                                    }
                                    return b;
                                })
                                if (timecard.timeRecordHours.every(a => a.isDelete === true)) {
                                    timecard.timeRecordHours.push({
                                        id: 0,
                                        hours: "0",
                                        hoursType: this.getHoursTypeCode(timecard.shift, Constants.ST),
                                        timeRecordID: timecard.timeRecordID > 0 ? timecard.timeRecordID : 0,
                                        deviceID: this.props.device.deviceId,
                                        isDelete: false
                                    });
                                }
                            }

                        }

                        let timeCardsRequestObject = timecards.slice().reverse();
                        //For Attachement inter changes
                        let payRollNote = timeCardsRequestObject[0].payrollNote ? timeCardsRequestObject[0].payrollNote : "";
                        for (let timecard of timeCardsRequestObject) {
                            timecard.payrollNote = timecard.payrollNote ? timecard.payrollNote : payRollNote;
                            if (timecard.timeRecordID === 0) {
                                timecard.modifiedDate = new Date();
                            }
                        }

                        let url = `${ApiUrls.Routes.TME_CRD_C}${ApiUrls.Routes.CRTE_OR_UPDE_TMECRDS}`;
                        Api.Post(url, timeCardsRequestObject, this).then((responseData) => {
                            if (responseData.success) {
                                this.setState({ isSaveButtonDisabled: false, isShowLoader: false, isShowTimecardsSaveConfirmation: false }, () => {
                                    this.props.history.push('TimeCard');
                                });
                            }
                            else {
                                this.setState({ isSaveButtonDisabled: false, isShowLoader: false });
                                MessageBox(responseData.message, Constants.ERROR);
                            }

                        }).catch(err => {
                            this.setState({ isSaveButtonDisabled: false, isShowLoader: false });
                            MessageBox(err, Constants.ERROR);
                        });
                    }
                });
            }
        }
        catch (err) {
            this.setState({ isSaveButtonDisabled: false, isShowLoader: false });
            MessageBox(err.message, Constants.ERROR);
        }
    }

    onClickBackButton = () => {
        const { timecards, savedTimeCards } = this.state;
        const updatedTimecards = timecards?.map(timecard => _.omit(timecard, ['modifiedBy', 'modifiedDate']));
        const savedTimeRecords = savedTimeCards?.map(timecard => _.omit(timecard, ['modifiedDate']));

        if (!_.isEqual(updatedTimecards, savedTimeRecords)) {
            this.setState({ isShowTimecardsSaveConfirmation: true });
        }
        else {
            this.onGoBack();
        }
    }

    onCloseShowTimecardsSaveConfirmation = () => {
        this.onGoBack();
    }

    onGoBack() {
        this.setState({ isShowTimecardsSaveConfirmation: false }, () => {
            this.props.history.push('TimeCard');
        });
    }

    onClickDeleteButton = (index) => {
        let { timecards, isTimeCardAttested } = this.state;
        if (isTimeCardAttested) {
            this.setState({ isShowAttestationErrorModal: true, attestErrorValidationMessage: Constants.TIMECARD_ALREADY_ATTESTED_MESSAGE });
            return;
        }

        if (timecards[index].timeRecordID > 0) {
            timecards[index].isDeleted = true;
        }
        else {
            timecards.splice(index, 1);
        }

        this.setState({ timecards });
    }

    getHoursValue(e) {
        e = e.trim();
        let hourValue = e === '.' ? e : isNaN(e) ? 0 : e;
        let hour = (typeof (hourValue) === "string" && hourValue.replace(/[^\d\.*]+/g, '')) ? hourValue.replace(/[^\d\.*]+/g, '') : 0;
        hour = hour != 0 ? hour.replace(/^0+/, '') : hour == '0.' ? hour : '0';
        return hour;
    }

    getHoursTypeCode(shift, hoursType) {
        switch (shift) {
            case Constants.EVENING:
                if (hoursType === Constants.ST)
                    return Constants.ST2;
                else if (hoursType === Constants.OT)
                    return Constants.OT2;
                else
                    return hoursType;
            case Constants.NIGHT:
                if (hoursType === Constants.ST)
                    return Constants.ST3;
                else if (hoursType === Constants.OT)
                    return Constants.OT3;
                else
                    return hoursType;
            case Constants.DAY:
                return hoursType;
            default:
                break;
        }
    }

    addOrUpdateTimeRecordHours = (timecard, hours, hourType, hourTypes) => {
        let index = timecard.timeRecordHours.findIndex(a => hourTypes.includes(a.hoursType) && !a.isDelete);
        if (Number(hours)) {
            if (index >= 0 && timecard.timeRecordHours[index]) {
                timecard.timeRecordHours[index].hours = Number(utility.hoursFormation(hours)).toString();
                timecard.timeRecordHours[index].hoursType = this.getHoursTypeCode(timecard.shift, hourType);
                timecard.timeRecordHours[index].timeRecordID = timecard.timeRecordID > 0 ? timecard.timeRecordID : 0;
                timecard.timeRecordHours[index].isUpdated = true;
            }
            else {
                timecard.timeRecordHours.push({
                    id: 0,
                    hours: Number(utility.hoursFormation(hours)).toString(),
                    hoursType: this.getHoursTypeCode(timecard.shift, hourType),
                    timeRecordID: timecard.timeRecordID > 0 ? timecard.timeRecordID : 0,
                    deviceID: this.props.device.deviceId,
                    isDelete: false
                });
            }
        }
        return timecard;
    }

    DeleteUnassignedAndInactiveProjectTimecards(timeCardIds) {
        let url = `${ApiUrls.Routes.TME_CRD_C}${ApiUrls.Routes.DL_UA_AND_IA_TMC}?deviceId=${this.props.device.deviceId}`;
        Api.Get(url, this).then(responseData => {
            if (responseData.success) {
                this.getTimecards(timeCardIds);
            } else {
                MessageBox(responseData.message, Constants.ERROR);
            }
        });
    }

    closeAlreadyAttestedPopup() {
        this.setState({ isShowAttestationErrorModal: false, attestErrorValidationMessage: "" });
    }

    render() {
        const {
            timecards,
            selectedDate,
            isShowSelectTaskCode,
            isViewAttachmentModelVisible,
            selectedAttachment,
            isShowTimecardsSaveConfirmation,
            isSaveButtonDisabled,
            projectOptions,
            shiftOptions,
            employeeName,
            employeeNumber,
            selectedTaskNumber,
            selectedTaskName,
            selectedProjectID,
            statusCodeDataList,
            selectedProjectNumber,
            isShowLoader, isTimeCardAttested, isShowAttestationErrorModal, attestErrorValidationMessage } = this.state;

        return (
            <TimeCardDetailsEditComponent
                {...{
                    timecard: {
                        employeeName,
                        employeeNumber,
                        timecards,
                        selectedDate,
                        projectOptions,
                        shiftOptions,
                        statusCodeDataList,
                        isShowSelectTaskCode,
                        selectedTaskNumber,
                        selectedTaskName,
                        selectedProjectID,
                        selectedProjectNumber,

                        isViewAttachmentModelVisible,
                        selectedAttachment,
                        isSaveButtonDisabled,

                        isShowTimecardsSaveConfirmation,
                        isShowLoader,
                        isTimeCardAttested,
                        isShowAttestationErrorModal,
                        attestErrorValidationMessage
                    }
                }}

                handleInputChange={this.handleInputChange.bind(this)}
                onClickDeleteButton={this.onClickDeleteButton.bind(this)}
                onShowSelectTaskCodePage={this.onShowSelectTaskCodePage.bind(this)}
                onHandleSelectTaskCodePageBackButton={this.onHandleSelectTaskCodePageBackButton.bind(this)}
                onHandleSelectTaskCodePageSelection={this.onHandleSelectTaskCodePageSelection.bind(this)}
                onAddActulNoteAttachment={this.onAddActulNoteAttachment.bind(this)}
                onRemoveActualNoteAttachment={this.onRemoveActualNoteAttachment.bind(this)}
                onClickViewActaulNoteAttachment={this.onClickViewActaulNoteAttachment.bind(this)}
                onCloseViewAttachment={this.onCloseViewAttachment.bind(this)}
                onClickAddNewLineButton={this.onClickAddNewLineButton.bind(this)}
                onClickSaveButton={this.onClickSaveButton.bind(this)}
                onClickBackButton={this.onClickBackButton.bind(this)}
                onCloseShowTimecardsSaveConfirmation={this.onCloseShowTimecardsSaveConfirmation.bind(this)}
                closeAlreadyAttestedPopup={this.closeAlreadyAttestedPopup.bind(this)}
            />
        );
    }
}

function mapStateToProps(state) {
    return {
        user: state.loginReducer.user,
        device: state.deviceReducer.device
    };
}

export default connect(mapStateToProps)(TimeCardDetailsEdit);

TimeCardDetailsEdit.displayName = "TimeCardDetailsEdit";